<template>
  <div id="size" v-bind:class="{vertical: !vertical && getMobile}">
    <div v-if="!vertical && getMobile">
      <h2 style="text-align: left; position: relative; top: 5px;">{{getText.title}}</h2>
        <SizeButtons :product="product" />
    </div>
    <div v-if="!vertical && getMobile">
      <v-card class="overflow-y-auto"
        max-height="200" style="background-color: #00000000; margin: 20px; box-shadow: none;">
      <SizeSlider :product="product"/>
    </v-card>
    </div>
    <div v-if="vertical || !getMobile">
      <h2 style="text-align: left; position: relative; top: 5px;">{{getText.title}}</h2>
      <SizeButtons :product="product" />
      <SizeSlider :product="product" />

    </div>
  </div>
</template>

<script>
import SizeSlider from '@/components/SizeSlider.vue'
import SizeButtons from '@/components/SizeButtons.vue'

export default {
  name: 'Size',
  props: ['product', 'vertical'],
  components: {
    SizeSlider,
    SizeButtons
  },
  data() {
    return{
    }
   },
   mounted (){
   },
   computed: {
     getMobile(){return this.$store.getters.getAnimationProperties.mobile;},
     getText(){
       return this.$store.getters.getText.configurator.dimensions
     },
   },
   watch: {
   },
   methods: {
   }
}
</script>

<style scoped>
.vertical{
  display: grid;
  position: relative;
  grid-template-columns: 1fr 1fr;
}

</style>
